var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.888569 7V0.454545H4.94752V1.30469H1.87614V3.29901H4.65668V4.14595H1.87614V7H0.888569ZM6.0853 7V2.09091H7.04091V7H6.0853ZM6.5679 1.33345C6.40171 1.33345 6.25895 1.27805 6.13963 1.16726C6.02245 1.05433 5.96385 0.920099 5.96385 0.764559C5.96385 0.606889 6.02245 0.472656 6.13963 0.36186C6.25895 0.248934 6.40171 0.192471 6.5679 0.192471C6.73409 0.192471 6.87579 0.248934 6.99297 0.36186C7.11229 0.472656 7.17195 0.606889 7.17195 0.764559C7.17195 0.920099 7.11229 1.05433 6.99297 1.16726C6.87579 1.27805 6.73409 1.33345 6.5679 1.33345ZM10.6181 2.09091V2.85795H7.9366V2.09091H10.6181ZM8.6557 0.914773H9.61131V5.55859C9.61131 5.74396 9.63901 5.88352 9.69441 5.97727C9.74981 6.06889 9.82119 6.13175 9.90854 6.16584C9.99803 6.1978 10.095 6.21378 10.1994 6.21378C10.2761 6.21378 10.3432 6.20845 10.4007 6.1978C10.4583 6.18714 10.503 6.17862 10.535 6.17223L10.7076 6.96165C10.6522 6.98295 10.5733 7.00426 10.471 7.02557C10.3688 7.04901 10.2409 7.06179 10.0875 7.06392C9.8361 7.06818 9.60173 7.02344 9.3844 6.92969C9.16707 6.83594 8.99129 6.69105 8.85705 6.49503C8.72282 6.29901 8.6557 6.05291 8.6557 5.75675V0.914773Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.7887ebbeaaee9d7771e7ecfacfb68343.svg";
export { ForwardRef as ReactComponent };